import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-grid-estadisticas-designacion-pd',
    templateUrl: './grid-estadisticas-designacion-pd.component.html'
})

export class GridEstadisticasDesignacionPdComponent implements OnInit {
    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 1;
    public totalItems: number;
    public firstItemList = 0;
    public lastItemList = this.itemsPerPage;
    public readonly visiblePages = 3;

    public showPais = false;
    public showDesignaciones = false;
    public showPorcentaje = false;
    public showDenominacion = false;
    public showCampanya = false;

    public desPais;
    public desDenominacion;

    @Input() dataGrid: any;
    @Input() currentTab; // Para la pestaña Kilos / Campañas

    @Output() hideTable = new EventEmitter<boolean>();
    
    constructor(
        private readonly _translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.totalItems = this.dataGrid.length;
        this.showRightFields();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    private showRightFields() {
        // Con que exista esa propiedad/no esté vacía en algún objeto, hay que mostrar ese campo
        this.dataGrid.forEach(object => {
            if (object.desPais) {
                this.showPais = true;
            }
            if (object.numDesignaciones || object.numero) {
                this.showDesignaciones = true;
            }
            if (object.porcentajeDesignaciones || object.porcentaje) {
                this.showPorcentaje = true;
            }
            if (object.desDenominacion) {
                this.showDenominacion = true;
            }
            if (object.anyo) {
                this.showCampanya = true;
            }

            // Para la pestaña Kilos / Campañas
            if (this.currentTab === 'kgCampanyasPaises') {
                this.desDenominacion = object.desDenominacion;
                this.showDenominacion = false;
            } else if (this.currentTab === 'kgCampanyasDenominaciones') {
                this.desPais = object.desPais;
                this.showPais = false;
            }
        })
    }

    public pageChange(page) {
        this.currentPage = page;
        this.firstItemList = this.itemsPerPage * (page - 1);
        this.lastItemList = this.itemsPerPage * page;
    }

    public itemsPerPageChange(items) {
        this.currentPage = 1;
        this.itemsPerPage = items;
        this.firstItemList = 0;
        this.lastItemList = items;
    }

    public close() {
        this.hideTable.emit(true);
    }
}